export const CLASS_NAMES = {
  disabled: 'PlanetCard-disabled',
  background: 'PlanetCard-background',
  planet: 'PlanetCard-planet',
  icon: 'PlanetCard-icon'
}
